import Mock from 'mockjs';
import qs from 'query-string';
import setupMock, { successResponseWrap } from '@/utils/setup-mock';
import { GetParams } from '@/types/global';

const data = Mock.mock({
  'list|60': [
    {
      'id|+1': 1,
      'user_id|+1': 1000,
      'nickname': '@cname',
      'avatar': '@image("200x100")',
      'mobile': /^1[3456789]\d{9}$/,
      'state|1': [1, 2, 3, 4],
      'last_report_time': '@date',
      'next_contact_time': '@date',
      'comsume_status|1': ['未消费', '已消费'],
      'master_nickname_id|+1': 200,
      'master_nickname': '@cname',
      'master_mobile': /^1[3456789]\d{9}$/,
      'master_group': '@cname',
    },
  ],
});

// 回访计划的mock数据
// const followUpSchedule = Mock.mock({
//   'list|7': [
//     {
//       'id|+1': 1,
//       'user_id|+1': 1000,
//       'customer_id|+1': 2000,
//       'staff_id|+1': 1000,
//       'content': '@cword(10, 20)',
//       'createtime': '@now',
//       'updatetime': '@now',
//     },
//   ],
// });

// 如果需要多个模拟请求接口，可以在 setupMock 的 setup 函数中多次调用 Mock.mock，分别拦截不同的接口地址。例如：

// 回访计划的mock数据
const followUpSchedule = Mock.mock({
  'list|20': [
    {
      'id|+1': 1,
      'user_id|+1': 1000,
      'customer_id|+1': 2000,
      'staff_id|+1': 3000,
      'content': '@cword(10, 20)',
      'createtime': '@datetime("yyyy-MM-dd HH:mm:ss")',
      'updatetime': '@datetime("yyyy-MM-dd HH:mm:ss")',
    },
  ],
});

setupMock({
  mock: false,
  setup() {
    // 回访列表接口
    Mock.mock(new RegExp('/business/customer_list'), (params: GetParams) => {
      const { current = 1, pageSize = 10 } = qs.parseUrl(params.url).query;
      const p = Number(current);
      const ps = Number(pageSize);
      return successResponseWrap({
        list: data.list.slice((p - 1) * ps, p * ps),
        total: data.list.length,
      });
    });

    // 回访计划列表接口
    Mock.mock(new RegExp('/business/contact_log_list'), (params: GetParams) => {
      const { current = 1, pageSize = 10 } = qs.parseUrl(params.url).query;
      const p = Number(current);
      const ps = Number(pageSize);
      return successResponseWrap({
        list: followUpSchedule.list.slice((p - 1) * ps, p * ps),
        total: followUpSchedule.list.length,
      });
    });
  },
});

// setupMock({
//   setup() {
//     Mock.mock(new RegExp('/api/followup'), (params: GetParams) => {
//       const { current = 1, pageSize = 10 } = qs.parseUrl(params.url).query;
//       const p = current as number;
//       const ps = pageSize as number;
//       return successResponseWrap({
//         list: data.list.slice((p - 1) * ps, p * ps),
//         total: 60,
//       });
//     });
//   },
// });
